import React, { Component } from "react";
// import { withRouter } from "react-router-dom";
import Classnames from "classnames";
import { observer } from "mobx-react";
import PropTypes from "prop-types";

import { MAP_SERVER_EN_ID } from "@/utils/getting";

// @withRouter
class HeroItem extends Component {
	static propTypes = {
		btag: PropTypes.string,
		classSlug: PropTypes.string,
		gender: PropTypes.number,
		hardcore: PropTypes.bool,
		history: PropTypes.object,
		id: PropTypes.number,
		level: PropTypes.number,
		name: PropTypes.string,
		server: PropTypes.number,
		stats: PropTypes.object
	}
	static defaultProps = {
		btag: "",
		classSlug: "unknow",
		gender: 0,
		hardcore: false,
		history: {},
		id: 0,
		level: 0,
		name: "",
		server: 0,
		stats: {}
	}
	render() {
		const { btag, classSlug, gender, hardcore, history, id, level, name, server, stats } = this.props;
		const { damage, healing, toughness } = stats;
		const hero = classSlug + (gender === 1 ? "-w" : "-m");
		return (
			<li className={`ladder-hero-item ${hero}`}>
				<div>
					<h5 className={Classnames("clearfix", { hand: hardcore })}>
						<span className="ellipsis">{name}</span>
						<em>{level}</em>
					</h5>
				</div>
				<p>伤害：<span>{damage || 0}</span></p>
				<p>坚韧：<span>{toughness || 0}</span></p>
				<p>治疗：<span>{healing || 0}</span></p>
				<a onClick={() => history.push(`/ladder/detail?btag=${btag}&hero=${id}&server=${server}`)}>进入英雄页面</a>
			</li>
		);
	}
}

@observer
class Hero extends Component {
	render() {
		const { battleTag, heroes, server } = Store._ladderStore.target;
		if (!heroes || !heroes.length) return null;
		const list = heroes.map(v => <HeroItem key={v.id} {...Object.assign({}, v, { btag: battleTag, server: MAP_SERVER_EN_ID[server] })} />);
		return <ul className="ladder-hero fl">{list}</ul>;
	}
}
export default Hero;